// extracted by mini-css-extract-plugin
module.exports = {"section-title":"style_section-title__2rie_","download-icon-list":"style_download-icon-list__1Jomr","textLeft":"style_textLeft__2DZaM"};